import { render } from "./OrderCreateSustainabilityAdvanced.vue?vue&type=template&id=6f6fe91b"
import script from "./OrderCreateSustainabilityAdvanced.vue?vue&type=script&lang=js"
export * from "./OrderCreateSustainabilityAdvanced.vue?vue&type=script&lang=js"

import "./OrderCreateSustainabilityAdvanced.vue?vue&type=style&index=0&id=6f6fe91b&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__